<template>
  <section class="section-container">
    <h1 class="section-container-heading">
      <p
        v-for="(line, index) in lines"
        :key="line.text"
        class="extra-large-text-list fade-up-animation"
        :class="{ 'special-text': line.special }">
        {{ line.text }}
      </p>
    </h1>
  </section>

  <section class="section-container section-container-double-gap">
    <div class="section-container-body fade-up-animation">
      <h3 class="heading-1">Build what's next, while earning from the value you help create.</h3>
      <p class="heading-4-bold">How It Works</p>
      <p class="body-text">
        Introduce Vortec to a company in need of a trusted technology partner, and earn
        <span class="body-text-bold">15% of the contract value for the first year</span>
        once we begin working together. For <span class="body-text-bold">each additional year</span> of partnership,
        you'll receive <span class="body-text-bold">5% annually</span> for ongoing support.
      </p>
      <p class="body-text">
        For example, a 12-month project with a dedicated team — including engineers, a product manager, and a designer —
        could earn you $20,000-$25,000 from the initial contract. If the partnership continues with extended support or
        scales with a larger team, your commission grows accordingly.
      </p>
      <p class="heading-4-bold">Your Referral Compensation Can Be</p>
      <ul>
        <li class="body-text">Deposited directly to your account</li>
        <li class="body-text">Applied as development credits if you're an active Vortec client</li>
      </ul>
    </div>
    <nuxt-link class="arrow-button arrow-button-bigger fade-up-animation" to="/contact" aria-label="Let's go">
      <p class="heading-4-bold">Get started</p>
      <div class="arrow-button-icon" v-html="[icons.rightArrowIcon, icons.rightArrowIcon]"></div
    ></nuxt-link>
  </section>
</template>

<script setup>
import icons from '~/icons';
import { useFadeUpObserver } from '@/composables/useFadeUpObserver';

const lines = [
  { text: 'Connect and', special: false },
  { text: 'Collect.', special: true },
];

useFadeUpObserver();

const referralDescription =
  "Build what's next, while earning from the value you help create. Introduce VORTEC to a company in need of a trusted technology partner, and earn commissions on successful partnerships.";

useSeo({
  title: 'Referrals | VORTEC',
  description: referralDescription,
  path: '/referrals',
  jsonLd: {
    '@type': 'WebPage',
    name: 'Referrals | VORTEC',
    description: referralDescription,
    url: 'https://vortec.io/referrals',
  },
});
</script>
